import React from 'react'
import { I18n } from 'galarm-config'
import { Box, Heading, RadioButtonGroup, Button } from 'grommet'
import { Constants } from 'galarm-config'

const SelectFirstDayOfWeek = ({ onClose, onSave, firstDayOfWeek }) => {
  const onSelectFirstDayOfWeek = label => {
    const selectedDay = Constants.DAYS_OF_WEEK.findIndex(day => day === label)
    if (selectedDay !== firstDayOfWeek) {
      onSave(selectedDay)
    }
  }

  return (
    <Box>
      <Heading margin="none" level={4}>
        {I18n.t('chooseFirstDayOfWeek')}
      </Heading>
      <Box margin={{ vertical: 'medium' }}>
        <RadioButtonGroup
          name="firstDayOfWeek"
          options={Constants.DAYS_OF_WEEK}
          value={Constants.DAYS_OF_WEEK[firstDayOfWeek]}
          onChange={event => onSelectFirstDayOfWeek(event.target.value)}
        />
      </Box>
      <Box
        direction="row"
        justify="center"
        gap="small"
        margin={{ top: 'small' }}>
        <Button onClick={onClose} label={I18n.t('ok')} />
      </Box>
    </Box>
  )
}

export default SelectFirstDayOfWeek
